<template>
    <div>
        <ul class="list-unstyled d-flex align-items-center gap-2 mb-0 pagination-common-style">
            <li>
                <a href="javascript:void(0);" @click="goToPage(currentPage - 1)" :class="{ disabled: !previous }">
                    <i class="bi bi-arrow-left"></i>
                </a>
            </li>
            <li v-for="page in totalPages" :key="page">
                <a href="javascript:void(0);" :class="{ active: currentPage === page }" @click="goToPage(page)">
                    {{ page }}
                </a>
            </li>
            <li>
                <a href="javascript:void(0);" @click="goToPage(currentPage + 1)" :class="{ disabled: !next }">
                    <i class="bi bi-arrow-right"></i>
                </a>
            </li>

        </ul>
        <div class="row">
            <div class="mt-4 text-muted col-1 text-center">Sayfa Sayısı<br>{{ currentPage }}/{{ totalPages }}</div>
            <div class="mt-4 text-muted col-1 text-center">Kayıt Sayısı<br>{{ recordCount }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        currentPage: { type: Number, required: true },
        totalPages: { type: Number, required: true },
        recordCount: { type: Number, required: true },
        previous: { type: [String, Boolean], default: null },
        next: { type: [String, Boolean], default: null },
    },
    emits: ['page-changed'],
    methods: {
        goToPage(page) {
            console.log('totalPage: ', this.totalPages);
            if (page < 1 || page > this.totalPages) return;
            this.$emit('page-changed', page);
        }
    }
}
</script>
